// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1FGRO","header":"MessagesList_header__3MS7-","chat":"MessagesList_chat__2QCvT"};